<template>
    <div>
        <div v-if="state === 'loading'">
            <Loader></Loader>
        </div>

        <div class="signing-top pdf-viewer-top">
            <div class="top">
                <div class="content">
                    <h1>{{ $t('review-sign.contract.headline') }}</h1>
                    <p v-if="draftContract.property"> {{ draftContract.property.address }}</p>
                </div>

                <router-link class="button purple" :to="{name: 'contracts'}">{{ $t('digital.pdf-viewer.close') }}</router-link>
            </div>
        </div>

        <div class="signing-content review">
            <div class="pdf-viewer">
                <PdfViewer v-if="pdfUrl !== null" :url="pdfUrl"  v-on:load="state = 'ready'"/>
            </div>
            <div class="button-container">
                <button class="purple" @click="download()" :disabled="state === 'saving'">
                    {{ $t('button.download.label') }}
                </button>
            </div>
        </div>

        <download-contract-modal
            v-if="showDownloadModal"
            v-on:close="showDownloadModal = false"
            :url="pdfUrl"
        />
    </div>
</template>

<script>
import Loader from "../../components/Loader";
import PdfViewer from "../../components/PdfViewer";
import DownloadContractModal from "../../components/DownloadContractModal";
import {mapGetters} from "vuex";

export default {
    name: "DigitalContractView",
    data: function () {
        return {
            state: 'loading',
            showDownloadModal: false,
            draftContract: {}
        };
    },
    components: {
        Loader,
        DownloadContractModal,
        PdfViewer
    },
    computed: {
        pdfUrl: function () {
            return window.config.apiUrl + `api/contract/${this.$route.params.id}.pdf?token=` + this.getToken;
        },
        ...mapGetters(['getToken'])
    },
    methods: {
        download() {
            this.showDownloadModal = true;
        }
    },
    mounted() {
        axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id,
            cancelToken: window.AuthorizationCancelSource.token,
        }).then(response => {
            this.draftContract = response.data;
            this.state = 'ready'
        })
    }
}
</script>

<style scoped>

</style>
